export function useSearchHistory() {
  const history = useState<string[]>('data:searchHistory', () => [])
  function getHistory() {
    // localStorage可能会被禁用
    const res = localStorage?.getItem('data:searchHistory') || '[]'
    try {
      if (res) {
        history.value = JSON.parse(res).slice(0, 30)
      }
    } catch {
      history.value = []
    }
  }

  function addToHistory(text: string) {
    getHistory()
    const index = history.value.indexOf(text)
    if (index >= 0) {
      history.value.splice(index, 1)
    }
    history.value.unshift(text)
    localStorage?.setItem(
      'data:searchHistory',
      JSON.stringify(history.value.slice(0, 30))
    )
  }

  function clear() {
    history.value = []
    localStorage?.removeItem('data:searchHistory')
  }

  return {
    history,
    getHistory,
    addToHistory,
    clear
  }
}
